import { useQuery, useQueryClient } from "@tanstack/react-query";
import { MessageSquare, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Stars } from "./ModelReviews";

export function AdminReviews() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["admin-reviews"], queryFn: async () => (await api.get("/admin/reviews")).data.reviews });

  const remove = async (id) => {
    if (!window.confirm("Supprimer cet avis ?")) return;
    try {
      await api.delete(`/admin/reviews/${id}`);
      toast.success("Avis supprimé");
      qc.invalidateQueries({ queryKey: ["admin-reviews"] });
      qc.invalidateQueries({ queryKey: ["review-summary"] });
    } catch {
      toast.error("Suppression impossible");
    }
  };

  return (
    <div className="mt-8 overflow-hidden rounded-xl border border-[#1E2638] bg-[#0F141C]" data-testid="admin-reviews">
      <div className="flex items-center gap-2 border-b border-[#1E2638] px-5 py-3">
        <MessageSquare className="h-4 w-4 text-primary" />
        <h2 className="font-head text-base font-bold">Avis des utilisateurs</h2>
      </div>
      <ul className="divide-y divide-[#1E2638]/60">
        {(data || []).length === 0 ? (
          <li className="px-5 py-4 text-sm text-muted-foreground">Aucun avis publié.</li>
        ) : data.map((r) => (
          <li key={r.id} data-testid="admin-review-item" className="flex flex-wrap items-start justify-between gap-3 px-5 py-3 text-sm">
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <span className="font-mono2 text-xs text-primary">{r.model_id}</span>
                <Stars value={r.rating} size="h-3.5 w-3.5" />
                <span className="font-mono2 text-[11px] text-muted-foreground">{r.author} · {new Date(r.created_at).toLocaleString("fr-FR")}</span>
              </div>
              {r.comment && <p className="mt-1 whitespace-pre-wrap break-words text-slate-300">{r.comment}</p>}
            </div>
            <button onClick={() => remove(r.id)} data-testid="admin-review-delete-button" className="rounded p-1.5 text-red-400 hover:bg-red-950/40" title="Supprimer">
              <Trash2 className="h-4 w-4" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
